module.exports = __webpack_public_path__ + "static/media/shark_button.b864e649.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/shark_button.png
// module id = 341
// module chunks = 0